import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useFieldLayout } from '../hooks/useMedia';
import { Timesheet } from '../modules/ComponentsLibrary/Timesheet';
import { TimesheetPhone } from '../modules/ComponentsLibrary/Timesheet/phone/TimesheetPhone';

export const Route = createFileRoute('/timesheet/$timesheetOwnerId')({
  component: RouteComponent,
  params: z.object({
    timesheetOwnerId: z.coerce.number().positive(),
  }),
  validateSearch: z.object({
    startOnWeek: z.boolean().optional(),
    week: z.string().date().optional(),
  }),
});

function RouteComponent() {
  const { timesheetOwnerId } = Route.useParams();
  const { startOnWeek, week } = Route.useSearch();
  // Phones and tablets get the phone layout; anywhere else that renders `Timesheet` stays desktop.
  const isFieldLayout = useFieldLayout();
  return isFieldLayout ? (
    <TimesheetPhone timesheetOwnerId={timesheetOwnerId} startOnWeek={startOnWeek} week={week} />
  ) : (
    <Timesheet timesheetOwnerId={timesheetOwnerId} startOnWeek={startOnWeek} week={week} />
  );
}
